/**
 * List of archived WhatsApp add-on plans that should be filtered out
 * from add-on plan selection dropdowns across the application
 */
export const ARCHIVED_WHATSAPP_ADDON_PLANS = [
  'sleekflow_v10_countrytier1_whatsapp_phone_number_enterprise_monthly_aed',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_enterprise_monthly_eur',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_enterprise_monthly_gbp',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_enterprise_monthly_hkd',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_enterprise_monthly_usd',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_enterprise_yearly_hkd',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_premium_monthly_hkd',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_premium_yearly_hkd',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_pro_monthly_hkd',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_pro_yearly_aed',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_pro_yearly_hkd',
  'sleekflow_v10_countrytier1_whatsapp_phone_number_pro_yearly_usd',
  'sleekflow_v10_countrytier2_whatsapp_phone_number_enterprise_monthly_sgd',
  'sleekflow_v10_countrytier2_whatsapp_phone_number_premium_monthly_sgd',
  'sleekflow_v10_countrytier2_whatsapp_phone_number_pro_yearly_sgd',
  'sleekflow_v10_countrytier4_whatsapp_phone_number_enterprise_monthly_myr',
  'sleekflow_v10_countrytier4_whatsapp_phone_number_premium_monthly_myr',
  'sleekflow_v10_countrytier5_whatsapp_phone_number_pro_monthly_idr',
  'sleekflow_v10_countrytier5_whatsapp_phone_number_pro_monthly_inr'
] as const;

/**
 * Helper function to filter out archived WhatsApp add-on plans from a list of plans
 * @param plans - Array of plan strings to filter
 * @returns Filtered array with archived WhatsApp add-on plans removed
 */
export const filterOutArchivedPlans = (plans: string[]): string[] => {
  return plans.filter(
    (plan) => !ARCHIVED_WHATSAPP_ADDON_PLANS.includes(plan as any)
  );
};

